import { z } from 'zod';

export const TriniPageContextSchema = z.object({
  url: z.string(),
  pathname: z.string(),
  pageTitle: z.string(),
  topic: z.string().optional(),
  brandId: z.string().optional(),
  projectId: z.string().optional(),
  folderId: z.string().optional(),
  conferenceId: z.string().optional(),
  callURL: z.string().optional(),
  surveyId: z.string().optional(),
  capturedAt: z.string(),
});

export type TriniPageContext = z.infer<typeof TriniPageContextSchema>;

export const TriniSubmitQueryExtensionSchema = z.object({
  agentType: z.literal('trini'),
  pageContext: TriniPageContextSchema,
});

export type TriniSubmitQueryExtension = z.infer<typeof TriniSubmitQueryExtensionSchema>;
